import { Dispatch, Fragment, SetStateAction, useState } from 'react';

import { Sidebar, TableSortPropertyState } from '@rr/ui';
import { useTeachersQuery } from 'types/graphql';

const LIMIT = 20;

interface TeacherListProps {
  handleCreate?: Dispatch<SetStateAction<boolean>>;
}

export const TeacherList = ({ handleCreate }: TeacherListProps) => {
  const [offset, setOffset] = useState(0);
  const [orderBy, setOrderBy] = useState<TableSortPropertyState>({
    first_name: 'asc',
  });

  const { error, data } = useTeachersQuery({
    variables: {
      offset,
      limit: LIMIT,
      order_by: { ...orderBy },
    },
  });

  if (error) {
    console.error(error);
    return <div>Error! Please check the console.</div>;
  }

  const teachers = data?.users || [];
  const updateOffset = (number: number) => setOffset(number);

  return (
    <Fragment>
      <Sidebar.Header title="Teachers" handleCreate={handleCreate} />
      <Sidebar.Content>
        {teachers &&
          teachers.map((teacher) => {
            return (
              <Sidebar.Item key={teacher.id} to={`/teachers/${teacher.id}`}>
                <div>
                  {teacher.first_name} {teacher.last_name}
                </div>
                <small>{teacher.email}</small>
              </Sidebar.Item>
            );
          })}
      </Sidebar.Content>
      <Sidebar.Footer
        updateOffset={updateOffset}
        offset={offset}
        limit={LIMIT}
        count={data?.users_aggregate.aggregate?.count}
      />
    </Fragment>
  );
};
